import { Researcher } from "./researcher";
import { Company } from "./company";
import { Model } from "./model";
import { Testbed } from "./testbed";
import { Box } from "./box";
import { ContractEvent } from "./contract-event";
import { Customer } from "./customer";

export class Contract extends Model {


  title?: string;
  description?: string;
  endDate?: Date;
  extendedEndDate?: Date;
  startDate?: Date;
  status?: string;
  note?: string;
  accepted?: boolean;
  numberOfBoxes?: number;
  thirdPartyContract?: number;

  researchers?: Researcher[];
  company?: Company;
  testbed?: Testbed;
  boxes?: Box[];
  events?: ContractEvent;

  contractReferent?: Customer;
  testbedReferentFirstName?: string;
  testbedReferentLastName?: string;
  testbedReferentEmail?: string;
  testbedReferentPhoneNumber?: string;


}
